import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const Forward = ({ strokeWidth = 1.5 }): JSX.Element => <g id={'contour'}>
    <path
        d='M2 8.33994V15.6599C2 17.1599 3.62999 18.0999 4.92999 17.3499L8.10001 15.5299L11.27 13.7C11.47 13.58 11.63 13.45 11.76 13.29V10.73C11.63
         10.57 11.47 10.44 11.27 10.32L8.10001 8.48993L4.92999 6.66996C3.62999 5.89996 2 6.83994 2 8.33994Z'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
    />
    <path
        d='M11.76 8.33994V15.6599C11.76 17.1599 13.39 18.0999 14.69 17.3499L17.86 15.5299L21.03 13.7C22.33 12.95 22.33 11.08 21.03 10.32L17.86
         8.48993L14.69 6.66996C13.39 5.89996 11.76 6.83994 11.76 8.33994Z'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
    />
</g>;

export default createSvg(
    Forward,
    'forward',
);
